import styled from "styled-components";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Cross1Icon } from "@radix-ui/react-icons";

const DocumentDialog = ({ open, onOpenChange, trigger, children, width }) => {
	return (
		<div className="hideScrollBar">
			<DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
				{trigger && (
					<DialogPrimitive.Trigger asChild>{trigger}</DialogPrimitive.Trigger>
				)}
				<DialogPrimitive.Portal>
					<Overlay />
					<DialogContent width={width}>
						<button
							type="button"
							onClick={() => onOpenChange(false)}
							className="absolute z-[100] top-6 right-6"
						>
							<Cross1Icon />
						</button>
						{children}
					</DialogContent>
				</DialogPrimitive.Portal>
			</DialogPrimitive.Root>
		</div>
	);
};

export default DocumentDialog;

const DialogContent = styled(DialogPrimitive.Content)`
  max-height: 80vh;
  max-width: ${({ width }) => (width ? width : "90%")};
  width: ${({ width }) => (width ? width : "90%")};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: fixed;
  background-color: var(--color-white);
  border: var(--spacing-microMinus) solid var(--color-line);
  border-radius: 10px;
  padding: var(--spacing-mediumMinus);
  box-shadow: 0 0 var(--spacing-small) rgba(0, 0, 0, 0.12);
  z-index: 100;
  overflow-y: auto;

  @media only screen and (min-width: 1219px) {
    width: ${({ width }) => (width ? width : "70vw")};
  }
`;

const Overlay = styled(DialogPrimitive.Overlay)`
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  z-index: 99;
  inset: 0;
`;
